import shouldSignInToSkypeOperation from 'owa-service/lib/operation/shouldSignInToSkypeOperation';

let shouldSignInPromise: Promise<boolean> = null;

export default function getShouldAutoSignIn(): Promise<boolean> {
    if (!shouldSignInPromise) {
        shouldSignInPromise = shouldSignInToSkypeOperation().catch(() => {
            return false;
        });
    }
    return shouldSignInPromise;
}
